module.exports = __webpack_public_path__ + "b8627a39b87520b3af46f63e08640233.png";